// src/data/translations.js

export const translations = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      plans: "Planes",
      labs: "Henki Labs",
      about: "Nosotros",
      academy: "Academia",
      community: "Comunidad",
      contact: "Contacto",
      themeDark: "Modo Oscuro",
      themeLight: "Modo Claro",
      quoteBtn: "Cotizar Proyecto",
      langSwitch: "English",
      langCode: "EN",
    },
    heroB2B: {
      badge: "ESTUDIO DE INGENIERÍA DE SOFTWARE & APPS",
      title: "Arquitectura robusta, auditoría técnica y software de alto impacto.",
      subtitle: "Ayudamos a startups, empresas y creadores a construir productos escalables, rescatar aplicaciones con fallos críticos y garantizar aprobaciones en Google Play Store con rigor de ingeniería.",
      ctaAudit: "Agendar Diagnóstico 24h",
      ctaServices: "Explorar Servicios",
      statUsers: "+100K",
      statUsersLabel: "Usuarios en nuestras apps",
      statApproval: "100%",
      statApprovalLabel: "Aprobación en Google Play",
      statSla: "24 Horas",
      statSlaLabel: "Diagnóstico de rescate",
      codeComment: "// Auditoría & Estabilidad de Aplicaciones",
      codeStatus: "Henki QA Protocol Active",
      trustedBy: "Confían en nuestra ingeniería y auditorías",
      whatsappAuditMsg: "¡Hola Henki! Me comunico para agendar un Diagnóstico Técnico 24h / Auditoría de mi aplicación o sistema.",
    },
    services: {
      title: "Servicios de Ingeniería & Soporte de Software",
      subtitle: "Ya sea que construiste tu app con IA, te entregaron un sistema con fallos o buscas un equipo técnico de confianza para tu empresa: hacemos que tu tecnología funcione.",
      pillars: {
        audit: {
          tag: "DIAGNÓSTICO EN 24H · RESCATE",
          title: "Auditoría de Software & Rescate Técnico",
          subtitle: "Revisamos tu sistema a fondo, encontramos errores y te decimos cómo resolverlos",
          description: "¿Te entregaron un software que falla, programaste tu app y se cuelga, o necesitas validar la calidad técnica antes de lanzar? Auditamos tu código y arquitectura en 24 horas, detectamos vulnerabilidades y te entregamos un diagnóstico claro con las soluciones exactas.",
          features: [
            "Detección y diagnóstico de caídas repentinas, lentitud y pantallas congeladas",
            "Auditoría de seguridad: revisión de datos sensibles, accesos y posibles brechas",
            "Control y auditoría de consumos de APIs o Inteligencia Artificial para evitar gastos sorpresa",
            "Informe claro sin tecnicismos + hoja de ruta con soluciones directas para corregir tu sistema",
          ],
          cta: "Solicitar Auditoría 24h",
          msg: "¡Hola Henki! Me interesa solicitar una Auditoría Técnica en 24h para revisar mi aplicación o sistema.",
        },
        qa: {
          tag: "14 DÍAS DE TESTING · DISPOSITIVOS REALES",
          title: "Pruebas Reales & Cumplimiento Google Play",
          subtitle: "Superamos el requisito de los 14 días y 12 testers con personas reales",
          description: "Google Play exige que 12 personas reales prueben tu app diariamente durante 14 días consecutivos antes de poder lanzarla. Nosotros coordinamos los testers y dispositivos físicos, detectamos errores visuales y bloqueos, y dejamos tu app lista para cumplir con los estándares de la tienda.",
          features: [
            "12 personas reales probando tu aplicación a diario en distintos modelos de teléfonos",
            "14 días continuos de interacción y actividad registrada según las exigencias de Google",
            "Detección oportuna de fallos, pantallas en blanco y cierres inesperados durante las pruebas",
            "Reporte detallado con capturas de errores visuales y sugerencias de mejora de usabilidad",
          ],
          cta: "Contratar 12 Testers para Google Play",
          msg: "¡Hola Henki! Necesito el servicio de 12 Testers por 14 días para cumplir los requisitos de prueba de mi app en Google Play.",
        },
        custom: {
          tag: "TU EQUIPO DE TECNOLOGÍA · A MEDIDA",
          title: "Desarrollo de Software, Soporte & Evolución Digital",
          subtitle: "Tu brazo técnico para cuidar tu plataforma y crear nuevas soluciones",
          description: "No te quedes sin respaldo técnico. Te ayudamos a evolucionar tu producto digital: construimos nuevas aplicaciones o funciones a medida, mantenemos tu plataforma estable y te asesoramos para que tu negocio crezca con tecnología confiable.",
          features: [
            "Desarrollo de aplicaciones móviles y plataformas web modernas adaptadas a tu negocio",
            "Acompañamiento técnico continuo para resolver dudas y mantener tu sistema al día",
            "Integración de Inteligencia Artificial práctica (asistentes, automatizaciones de procesos)",
            "Planes mensuales de soporte y mantenimiento para ser tu departamento de tecnología",
          ],
          cta: "Hablar con un Experto",
          msg: "¡Hola Henki! Quiero consultar sobre desarrollo de software y acompañamiento técnico para mi proyecto.",
        },
      },
    },
    labs: {
      badge: "HENKI LABS · PRODUCTOS DIGITALES PROPIOS",
      title: "Software propio validado por más de 100,000 usuarios.",
      subtitle: "No solo asesoramos a terceros: diseñamos, desplegamos y mantenemos nuestras propias apps y plataformas digitales en producción continua. La mejor prueba de maestría técnica es el software que nosotros mismos creamos y escalamos.",
      statDownloads: "+100,000",
      statDownloadsLabel: "Descargas y Usuarios Activos",
      statRating: "4.9 ★★★★★",
      statRatingLabel: "Calificación Promedio en Tiendas",
      specSheet: "Ficha Técnica",
      openApp: "Abrir aplicación",
      appItems: {
        "noise-app": {
          category: "Estilo de Vida",
          shortDescription: "Sonidos para calmar la mente y conciliar un sueño profundo.",
          tagline: "Donde el descanso se encuentra con el sonido perfecto.",
          fullDescription: "Noise App es la primera aplicación diseñada en Venezuela pensada exclusivamente para ayudarte a desconectarte del estrés diario, relajarte, meditar o concentrarte al máximo. Combina paisajes sonoros naturales grabados en alta definición con un temporizador inteligente de apagado.",
          features: [
            "Audios de lluvia, viento y mar.",
            "Temporizador de apagado diario.",
            "Funciona ideal sin conexión v4.",
          ],
          highlights: [
            "Ambientes sonoros 3D mezclables según tu estado de ánimo.",
            "Temporizador inteligente con atenuación progresiva de volumen.",
            "100% offline: disfruta sin gastar datos ni depender de WiFi.",
          ],
          badge: "App Móvil",
          downloads: "+50K descargas",
        },
        "pomodoros-app": {
          category: "Productividad",
          shortDescription: "Multiplica tu enfoque laboral con la técnica Pomodoro.",
          tagline: "Enfócate en lo que importa, elimina las distracciones.",
          fullDescription: "Pomodoros transforma la forma en que gestionas tu tiempo de trabajo y estudio. Basado en bloques científicamente probados de 25 minutos de enfoque activo seguidos de 5 minutos de descanso, te ayuda a mantener un estado de flujo sin llegar al agotamiento mental.",
          features: [
            "Reloj visual para tu progreso.",
            "Bloques fijos de 25 minutos.",
            "Diseño simple muy minimalista.",
          ],
          highlights: [
            "Reloj visual intuitivo con código de colores según la etapa.",
            "Bloques personalizables de trabajo (25m) y descansos cortos/largos.",
            "Alertas sonoras y hápticas discretas para no romper el enfoque.",
            "Interfaz ultraligera orientada al minimalismo digital.",
          ],
          badge: "App Móvil",
          downloads: "+30K descargas",
        },
        "lockly-app": {
          category: "Seguridad",
          shortDescription: "Multiplica tu seguridad digital con generador de claves.",
          tagline: "Tus contraseñas seguras y protegidas en todo momento.",
          fullDescription: "Lockly es tu guardián criptográfico personal. Permite generar contraseñas de alta seguridad de hasta 32 caracteres combinando símbolos, números y mayúsculas de manera impredecible, garantizando que tus cuentas permanezcan blindadas ante filtraciones.",
          features: [
            "Claves seguras para tu progreso.",
            "Genera claves de 25 caracteres.",
            "Diseño simple muy minimalista.",
          ],
          highlights: [
            "Generador instantáneo con entropía criptográfica avanzada.",
            "Evaluador visual de fortaleza de contraseñas en tiempo real.",
            "Copia rápida con un solo toque y auto-limpieza del portapapeles.",
            "Diseño moderno, privado y sin almacenamiento en servidores externos.",
          ],
          badge: "App Móvil",
          downloads: "+20K descargas",
        },
      },
    },
    aboutPage: {
      breadcrumbHome: "Inicio",
      breadcrumbCurrent: "Sobre Nosotros",
      badge: "EQUIPO & LIDERAZGO FUNDADOR",
      heroTitle: "Ingeniería de software de alto nivel forjada en ",
      heroCountry: "Venezuela",
      heroSubtitle: "En Henki no somos intermediarios. Somos ingenieros de software, directores de producto y estrategas digitales que construyen tecnología robusta para empresas, startups y proyectos de alto impacto a nivel global.",
      metricDownloads: "+100K",
      metricDownloadsLabel: "Descargas y usuarios activos en productos digitales propios",
      metricRating: "4.9 ★",
      metricRatingLabel: "Calificación promedio en Google Play Store",
      metricDelivery: "100%",
      metricDeliveryLabel: "Tasa de entrega en proyectos de software a medida y rescate de código",
      leadershipSub: "Liderazgo Ejecutivo y Técnico",
      leadershipTitle: "Conoce a los Fundadores",
      leadershipDesc: "Un enfoque complementario que une la excelencia en arquitectura de código con la gestión ágil de producto.",
      skillsHeading: "Especialidades clave:",
      principlesTitle: "Nuestros Principios de Trabajo",
      principlesSubtitle: "Cómo aseguramos que cada colaboración entregue software con valor real y medible.",
      principles: [
        {
          title: "Ingeniería con Resultados Reales",
          description: "No desarrollamos por desarrollar. Cada línea de código y cada sprint responde a los objetivos estratégicos y comerciales de tu negocio.",
        },
        {
          title: "Agilidad y Transparencia Absoluta",
          description: "Comunicación directa sin intermediarios burocráticos. Reportes claros, métricas de rendimiento y visibilidad en tiempo real.",
        },
        {
          title: "Compromiso de Producción Continua",
          description: "Diseñamos software resiliente y seguro. Auditamos arquitecturas para garantizar estabilidad, escalabilidad y cero tiempo de inactividad.",
        },
      ],
      ctaTitle: "¿Listo para construir o acelerar tu producto digital?",
      ctaSubtitle: "Hablemos sobre tu proyecto. Analizamos tu arquitectura, tus requerimientos de negocio y te entregamos un plan de ingeniería claro.",
      ctaWhatsapp: "Iniciar Conversación Directa 💬",
      ctaAcademy: "Ver Nuestra Academia 🎓",
    },
    community: {
      badge: "COMUNIDAD & DIVULGACIÓN TÉCNICA",
      title: "Ingeniería compartida con miles de desarrolladores.",
      subtitle: "A través de nuestro canal de YouTube y redes sociales, compartimos arquitectura de software, lecciones prácticas de Flutter, desarrollo web y DevOps. Creemos en elevar el estándar técnico de la comunidad mientras construimos productos reales.",
      btnExploreCourses: "Explorar Henki Academy 🎓",
      btnSubscribe: "Canal de YouTube",
      btnInstagram: "Instagram @henkivzla",
      cardSubtitle: "8+ Masterclasses y Cursos Especializados",
      feature1: "Flutter & Dart de Cero a Producción",
      feature2: "Arquitectura Limpia & Manejo de Estado",
      feature3: "Desarrollo de Videojuegos con Unity",
      cardCta: "Ver Catálogo de Cursos →",
    },
    coursesPage: {
      breadcrumbHome: "Inicio",
      breadcrumbCurrent: "Henki Academy & Tutoriales",
      badge: "HENKI ACADEMY · DIVULGACIÓN TÉCNICA",
      title: "Cursos Prácticos, Arquitectura & Código en YouTube",
      subtitle: "Compartimos con la comunidad el conocimiento y las buenas prácticas que aplicamos en proyectos reales: arquitectura en Android, automatización de DevOps, gestión ágil con Scrum y optimización de bases de datos.",
      subscribeBtn: "Suscribirse a @henkivzla",
      followInsta: "Seguir en Instagram",
      filterHeading: "Filtrar por especialidad técnica:",
      filterAll: "Todos los Cursos",
      filterMobile: "Desarrollo Android & Móvil",
      filterScrum: "Metodologías Ágiles & Scrum",
      filterDevOps: "DevOps & Cloud CI/CD",
      filterDB: "Bases de Datos & MySQL",
      filterTools: "Herramientas & Diseño UX",
      courseItems: {
        "vscode-complete": {
          title: "Visual Studio Code Completo",
          subtitle: "10 Lecciones · Buenas Prácticas",
          description: "Optimiza tu entorno de desarrollo y programa 2x más rápido con atajos y plugins esenciales.",
          badge: "¡Mejora tu Entorno!",
        },
        "scrum-cero": {
          title: "Scrum Profesional desde Cero",
          subtitle: "10 Lecciones · Conceptos Bases",
          description: "Organiza tus equipos de desarrollo, prioriza el backlog y escala tus entregas con éxito.",
          badge: "¡Lidera con Agilidad!",
        },
        "jetpack-compose": {
          title: "Jetpack Compose Guía Moderna",
          subtitle: "32 Lecciones · Arquitectura MVVM",
          description: "Diseña interfaces móviles reactivas y de alto rendimiento en Android usando Kotlin.",
          badge: "¡Diseña Apps Modernas!",
        },
        "android-studio-productividad": {
          title: "Android Studio Productividad",
          subtitle: "05 Lecciones · Tips de Expertos",
          description: "Domina el IDE oficial de Android y acelera tus tiempos de compilación al máximo.",
          badge: "¡Programa Más Rápido!",
        },
        "devops-practico": {
          title: "DevOps Práctico desde Cero",
          subtitle: "10 Lecciones · Pipelines CI y CD",
          description: "Automatiza despliegues continuos, gestiona servidores en la nube y asegura tus aplicaciones.",
          badge: "¡Domina la Cloud Hoy!",
        },
        "scrum-tips": {
          title: "Scrum Tips y Casos Prácticos",
          subtitle: "04 Lecciones · Enfoque Ágil Real",
          description: "Sana la comunicación de tu equipo, resuelve bloqueos y aumenta la velocidad de entrega.",
          badge: "¡Estrategias Reales!",
        },
        "mysql-optimizacion": {
          title: "MySQL y Optimización de Datos",
          subtitle: "16 Lecciones · Bases de Datos",
          description: "Diseña esquemas eficientes, crea índices óptimos y escribe consultas ultra rápidas.",
          badge: "¡Acelera tus Consultas!",
        },
        "miro-planificacion": {
          title: "Miro y Planificación Visual",
          subtitle: "10 Lecciones · Talleres de UX",
          description: "Estructura mapas de empatía, flujos de trabajo y prototipos en talleres colaborativos.",
          badge: "¡Crea Mapas de Éxito!",
        },
      },
    },
    vibesModal: {
      close: "Cerrar",
      installedBadge: "Google Play Store · Disponible",
      aboutApp: "Sobre",
      highlightsTitle: "Lo que obtendrás con esta app",
      downloadCTA: "Descargar en Google Play",
      tryWebCTA: "Abrir Versión Web",
      freeDownload: "100% Gratuita · Sin compras ocultas",
      specsTitle: "Ficha Técnica",
      category: "Categoría",
      compatibility: "Compatibilidad",
      androidReq: "Android 7.0+",
      developer: "Desarrollador",
      devName: "Henki Software",
    },
    videoSection: {
      title: "Aprende Gratis con Nuestros Cursos",
      subtitle: "Vídeos educativos paso a paso en YouTube sobre programación, agilidad y DevOps.",
      watchInSite: "Ver en la Web",
      openInYoutube: "Abrir en YouTube",
      lessons: "Lecciones",
    },
    youtubeModal: {
      close: "Cerrar Reproductor",
      openYoutube: "Ver en YouTube.com",
    },
    footer: {
      tagline: "Diseño, desarrollo y educación de alto nivel en Venezuela.",
      customerService: "Atención al Cliente",
      privacy: "Políticas de Privacidad",
      terms: "Términos y Condiciones",
      servicesLink: "Nuestros Servicios",
      aboutLink: "Sobre Nosotros",
      links: "Enlaces Directos",
      followUs: "Síguenos",
      contact: "Contacto",
      paymentsTitle: "Formas de Pago Aceptadas 💳",
      copyright: "© 2026 Henki. Todos los derechos reservados.",
      developedBy: "Desarrollado con pasión por @henkivzla",
      location: "📍 Venezuela",
    },
    termsPage: {
      breadcrumbHome: "Inicio",
      breadcrumbCurrent: "Términos y Condiciones",
      badge: "Marco Legal & Regulatorio",
      title: "Términos y Condiciones",
      lastUpdate: "Última actualización: 01 de agosto de 2025",
      sec1Title: "1. Uso de la Plataforma y Servicios",
      sec1Desc: "Puedes utilizar nuestros productos, plataformas y contenidos de forma personal y corporativa según los acuerdos establecidos. No está permitido copiarlos, distribuirlos o modificarlos sin autorización previa por escrito de Henki.",
      sec2Title: "2. Propiedad Intelectual",
      sec2Desc: "Todos los derechos de propiedad intelectual sobre nuestras aplicaciones, sistemas a medida, cursos, códigos fuente, marcas y elementos gráficos pertenecen a Henki y a sus respectivos autores, encontrándose amparados por las leyes vigentes de propiedad intelectual.",
      sec3Title: "3. Servicios de Testing y Garantías",
      sec3Desc: "Los servicios de QA y testing cerrado con 12 testers se ejecutan siguiendo los protocolos técnicos de Google Play. El cumplimiento de las políticas de la tienda respecto a contenidos del cliente es responsabilidad del desarrollador.",
      sec4Title: "4. Limitación de Responsabilidad",
      sec4Desc: "Henki no se hace responsable por interrupciones ajenas a nuestra infraestructura, fallos causados por servicios externos de terceros (como Firebase, Google Cloud, APIs externas) o mal uso de las plataformas.",
      sec5Title: "5. Contacto",
      sec5Desc: "Para cualquier duda o aclaración sobre estos términos, contáctanos en contacto@henki.com.ve.",
    },
    privacyPage: {
      breadcrumbHome: "Inicio",
      breadcrumbCurrent: "Política de Privacidad",
      badge: "Protección de Datos & Transparencia",
      title: "Política de Privacidad",
      lastUpdate: "Última actualización: 01 de agosto de 2025",
      intro: "En Henki valoramos y respetamos tu privacidad. Esta política describe con total transparencia cómo gestionamos y salvaguardamos los datos cuando utilizas nuestras aplicaciones, plataformas de software y servicios de ingeniería.",
      sec1Title: "1. Información que Recopilamos",
      sec1Desc: "Nuestras aplicaciones móviles (Noise App, Pomodoros, Lockly) están diseñadas bajo el principio de Privacidad por Diseño. No solicitamos registros innecesarios ni recopilamos información personal identificable (PII) sin tu consentimiento explícito. Únicamente se registran métricas anónimas de rendimiento y diagnóstico de fallos a través de Firebase Crashlytics para resolver bugs en producción.",
      sec2Title: "2. Uso de la Información",
      sec2Desc: "Cualquier dato técnico recolectado tiene como único fin garantizar la estabilidad, compatibilidad del sistema operativo y prevención de cierres inesperados de las aplicaciones. No comercializamos, alquilamos ni transferimos datos a terceros con fines publicitarios.",
      sec3Title: "3. Seguridad de los Datos",
      sec3Desc: "Implementamos estándares de encriptación y ofuscación (ProGuard/R8) en todo nuestro software para impedir accesos no autorizados a la información.",
      sec4Title: "4. Enlaces a Terceros",
      sec4Desc: "Nuestras plataformas pueden contener enlaces a servicios externos como Google Play o YouTube. No nos responsabilizamos por las políticas de privacidad de dichas plataformas.",
      sec5Title: "5. Contacto sobre Privacidad",
      sec5Desc: "Si tienes consultas sobre cómo tratamos la privacidad de tus datos, escríbenos a contacto@henki.com.ve.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      plans: "Plans",
      labs: "Henki Labs",
      about: "About Us",
      academy: "Academy",
      community: "Community",
      contact: "Contact",
      themeDark: "Dark Mode",
      themeLight: "Light Mode",
      quoteBtn: "Get a Quote",
      langSwitch: "Español",
      langCode: "ES",
    },
    heroB2B: {
      badge: "SOFTWARE ENGINEERING STUDIO & APPS",
      title: "Robust architecture, technical audits, and high-impact software.",
      subtitle: "We help startups, businesses, and creators build scalable digital products, rescue applications with critical bugs, and ensure Google Play Store approvals with engineering rigor.",
      ctaAudit: "Schedule 24h Diagnosis",
      ctaServices: "Explore Services",
      statUsers: "+100K",
      statUsersLabel: "Users across our apps",
      statApproval: "100%",
      statApprovalLabel: "Google Play Approval Rate",
      statSla: "24 Hours",
      statSlaLabel: "Rescue diagnosis SLA",
      codeComment: "// App Stability & Code Auditing",
      codeStatus: "Henki QA Protocol Active",
      trustedBy: "Trusted by founders and engineering teams",
      whatsappAuditMsg: "Hello Henki! I'd like to schedule a 24h Technical Diagnosis / Audit for my application or system.",
    },
    services: {
      title: "Engineering Services & Software Support",
      subtitle: "Whether you built your app with AI, received buggy software from third parties, or need a reliable external tech team: we make your technology work.",
      pillars: {
        audit: {
          tag: "24H DIAGNOSIS · RESCUE",
          title: "Software Audit & Technical Rescue",
          subtitle: "We thoroughly inspect your system, locate flaws, and outline exact solutions",
          description: "Were you delivered broken software, did your app start freezing, or do you need to validate code quality before going live? We audit your code and architecture in 24 hours, pinpoint vulnerabilities, and deliver a clear diagnosis with actionable fixes.",
          features: [
            "Detection and diagnosis of sudden crashes, lag, and frozen screens",
            "Security auditing: review of sensitive data, access controls, and potential leaks",
            "API and AI expense monitoring to prevent unexpected billing surprises",
            "Jargon-free executive report + clear roadmap with direct solutions for your team",
          ],
          cta: "Request 24h Audit",
          msg: "Hello Henki! I want to request a 24h Technical Audit to inspect my application or system.",
        },
        qa: {
          tag: "14 DAYS OF TESTING · REAL DEVICES",
          title: "Real-Device Testing & Google Play Compliance",
          subtitle: "We complete the mandatory 14-day, 12-tester requirement with real users",
          description: "Google Play requires 12 real people testing your app daily for 14 continuous days before you can release it. We coordinate real testers and physical devices, detect visual glitches and crashes, and get your app ready to meet store standards.",
          features: [
            "12 verified human testers actively engaging daily across multiple Android device models",
            "14 continuous days of recorded testing activity following Google Play criteria",
            "Timely detection of bugs, blank screens, and unexpected crashes during testing",
            "Comprehensive report with bug screenshots and actionable usability feedback",
          ],
          cta: "Hire 12 Testers for Google Play",
          msg: "Hello Henki! I need the 12 Testers for 14 Days service to fulfill Google Play testing requirements.",
        },
        custom: {
          tag: "YOUR ON-DEMAND TECH TEAM",
          title: "Custom Software Development & Product Evolution",
          subtitle: "Your engineering partner to protect your platform and build new solutions",
          description: "Don't get left without technical backing. We help your digital product thrive: building bespoke mobile apps and web platforms, maintaining platform stability, and guiding your business to scale with trustworthy technology.",
          features: [
            "Bespoke mobile apps and modern web platforms tailored to your business model",
            "Continuous technical support to answer questions and keep your system up to date",
            "Practical AI integration (smart assistants, automated business workflows)",
            "Flexible monthly support and maintenance plans acting as your technology department",
          ],
          cta: "Talk to an Expert",
          msg: "Hello Henki! I would like to consult on software development and technical support for my project.",
        },
      },
    },
    labs: {
      badge: "HENKI LABS · OWN DIGITAL PRODUCTS",
      title: "In-house software validated by over 100,000 active users.",
      subtitle: "We don't just advise clients: we build, deploy, and maintain our own digital applications and platforms in continuous production. The best proof of technical mastery is the software we build and scale ourselves.",
      statDownloads: "+100,000",
      statDownloadsLabel: "Downloads & Active Users",
      statRating: "4.9 ★★★★★",
      statRatingLabel: "Average Store Rating",
      specSheet: "Specs Sheet",
      openApp: "Open application",
      appItems: {
        "noise-app": {
          category: "Lifestyle",
          shortDescription: "Sounds to calm the mind and fall into a deep, peaceful sleep.",
          tagline: "Where deep relaxation meets acoustic perfection.",
          fullDescription: "Noise App is an ambient sound app designed in Venezuela to help you disconnect from daily stress, meditate, or reach deep focus. It blends high-definition nature soundscapes with an intelligent sleep timer.",
          features: [
            "Rain, wind, and ocean soundscapes.",
            "Daily automatic sleep timer.",
            "Seamless 100% offline playback.",
          ],
          highlights: [
            "Layered 3D soundscapes customizable to your mental flow.",
            "Smart timer with progressive, gentle volume fade-out.",
            "100% offline: enjoy anywhere without data usage or WiFi.",
          ],
          badge: "Mobile App",
          downloads: "+50K downloads",
        },
        "pomodoros-app": {
          category: "Productivity",
          shortDescription: "Boost your workflow focus with the proven Pomodoro technique.",
          tagline: "Focus on what matters, eliminate distractions.",
          fullDescription: "Pomodoros transforms how you manage your work and study time. Built around scientifically proven intervals of 25 minutes of laser focus followed by 5 minutes of restorative rest, keeping you in flow without burnout.",
          features: [
            "Visual clock tracking your session.",
            "Fixed 25-minute focus intervals.",
            "Minimalist, distraction-free UI.",
          ],
          highlights: [
            "Intuitive visual clock with adaptive color coding per stage.",
            "Customizable focus blocks (25m) and short/long breaks.",
            "Discreet audio and haptic cues to preserve flow state.",
            "Ultra-lightweight interface engineered for digital minimalism.",
          ],
          badge: "Mobile App",
          downloads: "+30K downloads",
        },
        "lockly-app": {
          category: "Security",
          shortDescription: "Elevate your digital safety with random strong password generator.",
          tagline: "Your passwords secure and armored at all times.",
          fullDescription: "Lockly is your personal cryptographic guardian. It generates high-security passwords up to 32 characters by combining symbols, digits, and cases unpredictably, ensuring your accounts remain impenetrable against breaches.",
          features: [
            "Strong passwords for your safety.",
            "Generates up to 32-char keys.",
            "Clean, zero-leak privacy design.",
          ],
          highlights: [
            "Instant generator with high-entropy cryptographic randomness.",
            "Real-time visual password strength evaluator.",
            "Quick one-tap copy with automatic clipboard wipe.",
            "Private-by-design: zero external server storage or telemetry.",
          ],
          badge: "Mobile App",
          downloads: "+20K downloads",
        },
      },
    },
    aboutPage: {
      breadcrumbHome: "Home",
      breadcrumbCurrent: "About Us",
      badge: "FOUNDING TEAM & LEADERSHIP",
      heroTitle: "High-tier software engineering forged in ",
      heroCountry: "Venezuela",
      heroSubtitle: "At Henki we are not intermediaries. We are software engineers, product leaders, and digital strategists building resilient technology for companies, startups, and high-impact initiatives globally.",
      metricDownloads: "+100K",
      metricDownloadsLabel: "Downloads and active users across our own digital products",
      metricRating: "4.9 ★",
      metricRatingLabel: "Average rating on Google Play Store",
      metricDelivery: "100%",
      metricDeliveryLabel: "Delivery track record in custom software & code rescue projects",
      leadershipSub: "Executive & Technical Leadership",
      leadershipTitle: "Meet the Founders",
      leadershipDesc: "A complementary synergy combining architectural code excellence with agile product delivery.",
      skillsHeading: "Key specializations:",
      principlesTitle: "Our Operating Principles",
      principlesSubtitle: "The foundation upon which we build long-term relationships with businesses and founders.",
      principles: [
        {
          title: "Engineering with Real Business Impact",
          description: "We don't code for the sake of coding. Every line and every sprint addresses your strategic, operational, and commercial objectives.",
        },
        {
          title: "Agility & Absolute Transparency",
          description: "Direct engineering communication without bureaucratic middlemen. Clear reporting, performance metrics, and live visibility.",
        },
        {
          title: "Continuous Production Commitment",
          description: "We build resilient, secure software. We audit systems to guarantee stability, horizontal scalability, and zero downtime.",
        },
      ],
      ctaTitle: "Ready to build or accelerate your digital product?",
      ctaSubtitle: "Let's talk about your project. We analyze your architecture and business requirements to deliver a clear engineering roadmap.",
      ctaWhatsapp: "Start Direct Conversation 💬",
      ctaAcademy: "Visit Our Academy 🎓",
    },
    community: {
      badge: "COMMUNITY & TECHNICAL OUTREACH",
      title: "Engineering shared with thousands of developers.",
      subtitle: "Through our YouTube channel and social media, we share software architecture, hands-on Flutter lessons, web development, and DevOps. We believe in elevating the technical bar of the community while building real-world products.",
      btnExploreCourses: "Explore Henki Academy 🎓",
      btnSubscribe: "YouTube Channel",
      btnInstagram: "Instagram @henkivzla",
      cardSubtitle: "8+ Masterclasses & Specialized Courses",
      feature1: "Flutter & Dart from Zero to Production",
      feature2: "Clean Architecture & State Management",
      feature3: "Video Game Development with Unity",
      cardCta: "View Course Catalog →",
    },
    coursesPage: {
      breadcrumbHome: "Home",
      breadcrumbCurrent: "Henki Academy & Tutorials",
      badge: "HENKI ACADEMY · TECHNICAL OUTREACH",
      title: "Hands-on Courses, Architecture & Code on YouTube",
      subtitle: "We share with the developer community the real-world practices we apply to production systems: Android architecture, DevOps automation, Agile Scrum management, and MySQL database optimization.",
      subscribeBtn: "Subscribe to @henkivzla",
      followInsta: "Follow on Instagram",
      filterHeading: "Filter by technical specialization:",
      filterAll: "All Courses",
      filterMobile: "Android & Mobile Development",
      filterScrum: "Agile Methodologies & Scrum",
      filterDevOps: "DevOps & Cloud CI/CD",
      filterDB: "Databases & MySQL",
      filterTools: "Tools & UX Design",
      courseItems: {
        "vscode-complete": {
          title: "Visual Studio Code Complete",
          subtitle: "10 Lessons · Best Practices",
          description: "Optimize your development workflow and code 2x faster with essential shortcuts and extensions.",
          badge: "Boost Your IDE!",
        },
        "scrum-cero": {
          title: "Professional Scrum from Scratch",
          subtitle: "10 Lessons · Core Foundations",
          description: "Organize dev teams, prioritize backlogs, and scale sprint deliverables with confidence.",
          badge: "Lead with Agility!",
        },
        "jetpack-compose": {
          title: "Modern Jetpack Compose Guide",
          subtitle: "32 Lessons · MVVM Architecture",
          description: "Design reactive, high-performance Android mobile interfaces using modern Kotlin.",
          badge: "Build Modern Apps!",
        },
        "android-studio-productividad": {
          title: "Android Studio Productivity",
          subtitle: "05 Lessons · Expert Tips",
          description: "Master the official Android IDE and speed up your Gradle build times to the maximum.",
          badge: "Code Faster Today!",
        },
        "devops-practico": {
          title: "Practical DevOps from Scratch",
          subtitle: "10 Lessons · CI/CD Pipelines",
          description: "Automate continuous deployments, manage cloud servers, and secure your production web apps.",
          badge: "Master the Cloud!",
        },
        "scrum-tips": {
          title: "Scrum Tips & Real Case Studies",
          subtitle: "04 Lessons · Pragmatic Agility",
          description: "Improve team communication, resolve blocking issues, and accelerate sprint velocity.",
          badge: "Battle-Tested Tactics!",
        },
        "mysql-optimizacion": {
          title: "MySQL & Database Optimization",
          subtitle: "16 Lessons · Production DBs",
          description: "Design clean schemas, create optimal B-Tree indexes, and write ultra-fast SQL queries.",
          badge: "Speed Up Queries!",
        },
        "miro-planificacion": {
          title: "Miro & Visual UX Planning",
          subtitle: "10 Lessons · UX Workshops",
          description: "Structure empathy maps, user journeys, and wireframe prototypes in collaborative boards.",
          badge: "Design Winning Maps!",
        },
      },
    },
    vibesModal: {
      close: "Close",
      installedBadge: "Google Play Store · Available",
      aboutApp: "About",
      highlightsTitle: "What you get with this app",
      downloadCTA: "Download on Google Play",
      tryWebCTA: "Open Web Version",
      freeDownload: "100% Free · No hidden purchases",
      specsTitle: "Technical Specs",
      category: "Category",
      compatibility: "Compatibility",
      androidReq: "Android 7.0+",
      developer: "Developer",
      devName: "Henki Software",
    },
    videoSection: {
      title: "Learn Free with Our Courses",
      subtitle: "Step-by-step educational YouTube videos on programming, agile, and DevOps.",
      watchInSite: "Watch On Site",
      openInYoutube: "Open in YouTube",
      lessons: "Lessons",
    },
    youtubeModal: {
      close: "Close Player",
      openYoutube: "Watch on YouTube.com",
    },
    footer: {
      tagline: "High-tier design, software development, and tech education based in Venezuela.",
      customerService: "Customer Care",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      servicesLink: "Our Services",
      aboutLink: "About Us",
      links: "Quick Links",
      followUs: "Follow Us",
      contact: "Contact",
      paymentsTitle: "Accepted Payment Methods 💳",
      copyright: "© 2026 Henki. All rights reserved.",
      developedBy: "Developed with passion by @henkivzla",
      location: "📍 Venezuela",
    },
    termsPage: {
      breadcrumbHome: "Home",
      breadcrumbCurrent: "Terms & Conditions",
      badge: "Legal & Regulatory Framework",
      title: "Terms and Conditions",
      lastUpdate: "Last updated: August 01, 2025",
      sec1Title: "1. Platform and Services Usage",
      sec1Desc: "You may use our software products, platforms, and educational materials for personal and corporate purposes according to agreed service contracts. Copying, redistributing, or modifying them without prior written authorization from Henki is prohibited.",
      sec2Title: "2. Intellectual Property",
      sec2Desc: "All intellectual property rights regarding our applications, custom codebases, courses, source repositories, trademarks, and visual assets belong to Henki and their respective creators, protected under applicable intellectual property laws.",
      sec3Title: "3. Testing Services & Guarantees",
      sec3Desc: "Closed QA testing with 12 testers follows Google Play technical policies and guidelines. Full compliance of client app content and store listing policies remains the developer's responsibility.",
      sec4Title: "4. Limitation of Liability",
      sec4Desc: "Henki is not liable for service interruptions outside our direct control, or outages caused by third-party cloud infrastructure (such as Firebase, Google Cloud, external APIs).",
      sec5Title: "5. Contact Information",
      sec5Desc: "For any inquiries regarding these terms, reach us at contacto@henki.com.ve.",
    },
    privacyPage: {
      breadcrumbHome: "Home",
      breadcrumbCurrent: "Privacy Policy",
      badge: "Data Protection & Transparency",
      title: "Privacy Policy",
      lastUpdate: "Last updated: August 01, 2025",
      intro: "At Henki we value and respect your privacy. This policy transparently outlines how we manage and safeguard information when you use our applications, software platforms, and engineering services.",
      sec1Title: "1. Information We Collect",
      sec1Desc: "Our mobile applications (Noise App, Pomodoros, Lockly) are designed under Privacy by Design principles. We do not require unnecessary user accounts nor collect personally identifiable information (PII) without explicit consent. Only anonymized crash and performance metrics are tracked via Firebase Crashlytics to resolve production bugs.",
      sec2Title: "2. Information Usage",
      sec2Desc: "Any technical data collected is used solely to maintain application stability, operating system compatibility, and fatal error prevention. We do not sell, rent, or trade user data to third parties for advertising purposes.",
      sec3Title: "3. Data Security",
      sec3Desc: "We implement code obfuscation (ProGuard/R8) and secure encryption standards across all our software to prevent unauthorized access.",
      sec4Title: "4. Third-Party Links",
      sec4Desc: "Our platforms may link to external services like Google Play or YouTube. We are not responsible for the privacy policies of external platforms.",
      sec5Title: "5. Privacy Contact",
      sec5Desc: "If you have questions regarding our data privacy practices, email us at contacto@henki.com.ve.",
    },
  },
};
